var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTaskAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1183_666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1183_666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5034 21C11.2588 21 10.0887 20.7638 8.9931 20.2915C7.89748 19.8192 6.94444 19.1782 6.13397 18.3685C5.32352 17.5588 4.68192 16.6066 4.20915 15.512C3.73638 14.4174 3.5 13.2479 3.5 12.0034C3.5 10.7588 3.73625 9.58872 4.20875 8.4931C4.68125 7.39748 5.3225 6.44444 6.1325 5.63398C6.9425 4.82353 7.895 4.18192 8.99 3.70915C10.085 3.23638 11.255 3 12.5 3C13.5235 3 14.4918 3.15833 15.4051 3.475C16.3184 3.79167 17.1513 4.23333 17.9038 4.8L17.1846 5.54422C16.5256 5.05449 15.8008 4.67468 15.0101 4.4048C14.2194 4.13493 13.3827 4 12.5 4C10.2833 4 8.39583 4.77917 6.8375 6.3375C5.27917 7.89583 4.5 9.78333 4.5 12C4.5 14.2167 5.27917 16.1042 6.8375 17.6625C8.39583 19.2208 10.2833 20 12.5 20C14.7167 20 16.6042 19.2208 18.1625 17.6625C19.7208 16.1042 20.5 14.2167 20.5 12C20.5 11.5974 20.4705 11.2026 20.4116 10.8155C20.3526 10.4284 20.2641 10.0521 20.1462 9.68655L20.9442 8.86922C21.1276 9.36409 21.266 9.87181 21.3596 10.3924C21.4532 10.9129 21.5 11.4488 21.5 12C21.5 13.245 21.2638 14.415 20.7915 15.51C20.3192 16.605 19.6782 17.5575 18.8685 18.3675C18.0588 19.1775 17.1066 19.8188 16.012 20.2913C14.9174 20.7638 13.7479 21 12.5034 21ZM11.0616 15.9077L7.50385 12.35L8.21155 11.6423L11.0616 14.4923L20.7923 4.75578L21.5 5.46345L11.0616 15.9077Z",
    fill: "#39A887"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskAlt);
export default __webpack_public_path__ + "static/media/task-alt.41c7befe6bae20cf25c98a6cac987862.svg";
export { ForwardRef as ReactComponent };